import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { scNotifications, getSidecarToken, notificationsStreamUrl } from "@/lib/api";
import { initNotifications, notify } from "@/lib/native";

const NotificationsCtx = createContext({ counts: { certify_unread: 0, pulse_unread: 0 } });
export const useNotifications = () => useContext(NotificationsCtx);

// Single shared SSE connection for unread counters. Pages subscribe via useNotifications()
// to auto-refresh their lists when a counter changes, without opening extra streams.
export function NotificationsProvider({ children }) {
  const { isAuth } = useAuth();
  const [counts, setCounts] = useState({ certify_unread: 0, pulse_unread: 0 });
  const prevCounts = useRef(null);

  useEffect(() => {
    if (!isAuth) { setCounts({ certify_unread: 0, pulse_unread: 0 }); prevCounts.current = null; return; }
    initNotifications();
    let active = true, es = null, poll = null;
    const apply = (d) => {
      if (!active || !d) return;
      const prev = prevCounts.current;
      if (prev) {
        if ((d.pulse_unread || 0) > (prev.pulse_unread || 0)) notify("Nuovo messaggio Pulse", "Hai un nuovo messaggio cifrato.", "/pulse");
        if ((d.certify_unread || 0) > (prev.certify_unread || 0)) notify("Nuova comunicazione certificata", "Hai ricevuto una nuova comunicazione su Certify.", "/certify");
        if ((d.leads_unread || 0) > (prev.leads_unread || 0)) notify("Nuova richiesta", "Una nuova azienda ha inviato una richiesta.", "/console");
      }
      prevCounts.current = d;
      setCounts(d);
    };
    (async () => {
      try {
        const token = await getSidecarToken();
        if (!active) return;
        es = new EventSource(notificationsStreamUrl(token));
        es.onmessage = (e) => { try { apply(JSON.parse(e.data)); } catch { /* noop */ } };
        es.onerror = () => {
          es?.close(); es = null;
          if (active && !poll) { scNotifications().then(apply).catch(() => {}); poll = setInterval(() => scNotifications().then(apply).catch(() => {}), 12000); }
        };
      } catch {
        scNotifications().then(apply).catch(() => {});
        poll = setInterval(() => scNotifications().then(apply).catch(() => {}), 12000);
      }
    })();
    return () => { active = false; es?.close(); if (poll) clearInterval(poll); };
  }, [isAuth]);

  return <NotificationsCtx.Provider value={{ counts }}>{children}</NotificationsCtx.Provider>;
}
